/**
 * oss上传组件
 * @description oss上传
 * @author mll
 * @date 2020-4-1
 */
import React, { Component } from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool, utils_tool } from '../../../tool'
let { WizContainer, WizOssUpload, WizAvatarUpload, ossFileUtils } = framework_tool;
let { WizCard, WizAntdForm, WizRow, WizCol, WizButton, WizTypography } = component_tool
const { Title, Paragraph, Text } = WizTypography;

import { Base64 } from 'js-base64';
class OssUpload extends Component {

  state = {};

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        log.info('form submit:', values)
      }
    });
  };

  handleReset = () => {
    //重置表单
    this.props.form.resetFields();
  };

  defaultFile = () => {
    return [
      {
        fileId: '2020031713331428069d34b640481396'}, {
        fileId: "20200415182442de8cdfe1d3bc486f82",
        fileNewName: "20200415182442de8cdfe1d3bc486f82.docx",
        fileOriginalName: "#培训一码项目需求-3.docx",
        fileType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        name: "#19960培训一码项目需求-3.docx",
        percent: 100,
        size: 15319457,
        status: "error",
        sysUrl: "temp/doc/20200415182442de8cdfe1d3bc486f82.docx",
        thumbUrl: "",
        uid: "rc-upload-1586946273197-1",
        url: ""
      }
    ]
  }

  _info = () => {
    return (
      <WizCard title='介绍' icon={0}>
        <Paragraph>
          本组件是集成了上传阿里云的选择文件组件，基于antd-upload进行改写，支持antd-upload的属性。支持正常使用和集成在表单中。
        </Paragraph>
        <Paragraph strong>
          文件上传的整体流程：
        </Paragraph>
        <Paragraph>
          1、用户选择文件
        </Paragraph>
        <Paragraph>
          2、向服务端索要上传凭证
        </Paragraph>
        <Paragraph>
          3、把用户选中的文件注册到服务端
        </Paragraph>
        <Paragraph>
          4、文件上传阿里云
        </Paragraph>
        <Paragraph>
          5、文件上传成功后，归档服务
        </Paragraph>
        <Paragraph strong>
          普通上传、分片上传：
        </Paragraph>
        <Paragraph>
          组件根据文件的大小自动选择上传方式，大于1MB的文件使用分片上传。
        </Paragraph>
        <Paragraph strong>
          断点续传：
        </Paragraph>
        <Paragraph>
          当文件分片上传出现异常情况时，会触发断点续传。
        </Paragraph>
        <Paragraph>
          1、某一片文件上传失败
        </Paragraph>
        <Paragraph>
          2、网络断开，重连后
        </Paragraph>
        <Paragraph>
          3、上传凭证失效时
        </Paragraph>
      </WizCard>
    )
  }

  /**
   * 上传的例子
   */
  _upload = () => {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return [
      <>{this._info()}</>,
      <WizCard title='支持多选的文件列表' icon={0}>
        <WizOssUpload key={1}
          multiple
          listType={'texst'}
          uploadType={'temp'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
        />
      </WizCard>,
      <WizCard title='图片' icon={0}>
        <WizOssUpload key={2}
          accept={'.jpg, .jpeg, .png'}
          listType={'picture'}
          uploadType={'temp'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
        />
      </WizCard>,
      <WizCard title='卡片形式的图片(Oss)' icon={0}>
        <WizOssUpload key={3}
          accept={'.jpg, .jpeg, .png'}
          listType={'picture-card'}
          uploadType={'temp'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
        />
      </WizCard>,
      <WizCard title='卡片形式的图片()' icon={0}>
        <WizOssUpload key={'3_1'}
          accept={'.jpg, .jpeg, .png'}
          listType={'picture-card'}
          uploadType={'temp'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
          uploadWay={''}
        />
      </WizCard>,
      <WizCard title='头像上传专用组件' icon={0}>
        <WizAvatarUpload key={3}
          accept={'.jpg, .jpeg, .png'}
          listType={'picture-card'}
          uploadType={'temp'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
        />
      </WizCard>,
      <WizCard title='与表单联用' icon={0}>
        <WizAntdForm
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          <WizAntdForm.Item label="上传" >
            {getFieldDecorator('uploadFile', {
              initialValue: [...this.defaultFile()],
              rules: [
                { required: true, message: '请选择文件' },
              ],
            })(
              <WizOssUpload
                multiple
                uploadType={'temp'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
              />
            )}
          </WizAntdForm.Item>
          <WizAntdForm.Item wrapperCol={{ span: 12, offset: 6 }}>
            <WizRow>
              <WizCol span={24} style={{ textAlign: 'center' }}>
                <WizButton type="primary" htmlType="submit">
                  保存
                        </WizButton>
                <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                  重置
                        </WizButton>
              </WizCol>
            </WizRow>
          </WizAntdForm.Item>
        </WizAntdForm>
      </WizCard>
    ]
  }

  /**
   * 获取url是对图片进行处理
   */
  _selectImg = () => {
    return (
      <WizCard title='获取url是对图片进行处理' icon={0}>
        <WizRow>
          <WizOssUpload key={2}
            accept={'.jpg, .jpeg, .png'}
            listType={'picture'}
            uploadType={'temp'}
            showUploadList={false}
            onChange={(files) => {
              this.setState({
                changeImg: files[files.length - 1],
                time: new Date()
              })
            }}
          />
        </WizRow>
      </WizCard>
    )
  }

  _changeImg = () => {
    let l = []
    let { changeImg } = this.state;
    if (changeImg) {
      //直接获取fileUrl
      let fixed = ossFileUtils.getOssImgResizeUrl(
        changeImg['sysUrl'],
        { m: 'fixed', w: 100, h: 100 }
      )
      //通过file获取的file对象
      let fileParams = {
        fileId: changeImg['fileId'],
        fileOriginalName: changeImg['fileOriginalName'],
        fileType: changeImg['fileType'],
        fileSize: changeImg['size'],
        fileUri: changeImg['sysUrl'],
        access: true
      }
      let lfit = ossFileUtils.getOssImgResize(
        fileParams,
        { m: 'lfit', l: 500 }
      )
      l.push(
        <WizCard>
          <WizRow>
            <Paragraph>
              固定宽度，长宽都为100px的图片：
            </Paragraph>
            <img key={fixed} src={fixed} />
          </WizRow>
          <WizRow>
            <Paragraph>
              等比例缩放，最长边为500：
            </Paragraph>
            <img key={lfit['url']} src={lfit['url']} />
          </WizRow>
        </WizCard>
      )
      let watermark = ossFileUtils.getOssImgFile(
        fileParams,
        {
          watermark: 'text_' + Base64.encodeURI('我是水印'),
          resize: 'm_lfit,l_500'
        }
      )
      l.push(
        <WizCard>
          <WizRow>
            <Paragraph>
              文字水印：
            </Paragraph>
            <img key={watermark['url']} src={watermark['url']} />
          </WizRow>
        </WizCard>
      )

    }
    return l
  }

  render() {
    return (
      <>
        {this._upload()}
        {this._selectImg()}
        {this._changeImg()}
      </>
    )
  }
}

export default WizAntdForm.create()(OssUpload);
